export const NEW_CHANGE_LABEL = "New";
export const UNCHANGED_CHANGE_LABEL = "+0.0%";

export type UsageChange = {
  change: string;
  changeType: "increase" | "decrease";
  noActivity: boolean;
};

export function hasUsageTrend(comparison: UsageChange): boolean {
  return !comparison.noActivity && !!comparison.change && comparison.change !== UNCHANGED_CHANGE_LABEL;
}

/** A zero baseline has no percentage change; unavailable comparisons stay blank. */
export function calculateUsageChange(current: number | undefined, previous?: number): UsageChange {
  if (
    current === undefined || previous === undefined ||
    !Number.isFinite(current) || !Number.isFinite(previous) ||
    current < 0 || previous < 0
  ) {
    return { change: "", changeType: "increase", noActivity: false };
  }
  if (current === 0 && previous === 0) {
    return { change: "", changeType: "increase", noActivity: true };
  }
  if (previous === 0) {
    return { change: NEW_CHANGE_LABEL, changeType: "increase", noActivity: false };
  }
  // Classify the rounded value so tiny changes display as a neutral zero.
  const percentChange = Number((((current - previous) / previous) * 100).toFixed(1));
  if (!Number.isFinite(percentChange)) {
    return { change: "", changeType: "increase", noActivity: false };
  }
  const sign = percentChange >= 0 ? "+" : "";
  return {
    // Emit the canonical neutral label that hasUsageTrend recognizes.
    change: percentChange === 0 ? UNCHANGED_CHANGE_LABEL : `${sign}${percentChange.toFixed(1)}%`,
    changeType: percentChange >= 0 ? "increase" : "decrease",
    noActivity: false,
  };
}
